import type { FC } from 'react';

import { Body, Headline } from '@zen/DesignSystem';

interface Props {
  subtitle: string;
  title: string;
}

const WizardStepHeader: FC<Props> = ({ subtitle, title }) => {
  return (
    <div className="mb-6 space-y-1" data-component="wizard-step-header">
      <Headline level={1}>{title}</Headline>
      <Body className="text-grey-base">{subtitle}</Body>
    </div>
  );
};

export type { Props as WizardStepHeaderProps };
export default WizardStepHeader;
